import React from 'react';
import './dropdown-list.scss';
import classNames from 'classnames';

interface DropdownListProps {
    title?: string;
    list: { label: string; isActive: boolean; value: string; gtm: string; }[];
    value: string[];
    multi?: boolean;
    onSelect: (value: string) => void;
}

const DropdownList: React.FC<DropdownListProps> = props => (
    <div className="dropdown-list">
        { props.title && (
            <div className="dropdown-list__title">
                {props.title}
            </div>
        )}
        { props.list.map(item => (
            <div
                className={classNames({
                    'dropdown-list__item': true,
                    'dropdown-list__item--active': item.isActive,
                    'dropdown-list__item--selected': props.value.find(v => v === item.value),
                    'dropdown-list__item--checkboxes': props.multi
                }, item.gtm || void 0)}
                key={item.value}
                role="button"
                tabIndex={0}
                onClick={(): void | false => item.isActive && props.onSelect(item.value)}
            >
                { props.multi && <i className="icon-check-none"/>}
                { item.label }
            </div>
        ))}
    </div>
);

export default DropdownList;
